/*
=========================================================
* Otis Kit PRO - v2.0.2
=========================================================

* Product Page: https://material-ui.com/store/items/otis-kit-pro-material-kit-react/
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import React, { useState } from "react";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
// Presentation page sections
import Counters from "pages/presentation/sections/Counters";
import ComplexReviewCard from "examples/Cards/ReviewCards/ComplexReviewCard";
// Presentation page components
import PastorSisterBerry from "../../assets/images/PastorSisBerry.jpeg";
// Images
import bgImage from "../../assets/images/bg-presentation.jpeg";

function Presentation() {

  return (
    <>

      <DefaultNavbar
        routes={[]}
        action={{
          label: "Give",
          color: "info",
          route: "https://www.zeffy.com/en-US/donation-form/tithes-and-offerings-191"
        }}
        transparent
        center
      />
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: ({ palette: { gradients }, functions: { linearGradient, rgba } }) =>
            `linear-gradient(to bottom, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0)), url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          display: "flex",
          placeItems: "center",
          alignItems: "flex-start"
        }}
      >
      </MKBox><Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Counters />
      </Card>

      <br />
      <br />

      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <ComplexReviewCard
          image={PastorSisterBerry}
          title="About"
          review="Calvary Worship Center is an exciting, diverse and growing Church where you will hear strong preaching of the Word and experience Spirit filled worship."
          author={{
            // logo: logoSpotify,
            name: "Pastor: Robert W Berry",
          }}
        />

      </Card>
      <br />
      <br />
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >


        <MKBox component="section" >
          <Container>
            <Grid
              container
              item
              justifyContent="center"
              xs={10}
              lg={7}
              mx="auto"
              mb={{ xs: 0, md: 1 }}
              textAlign="center"
              display={"flex"}
              flexDirection={"column"}
            >
              <MKTypography variant="h3" mb={.5}>
                Contact Us
              </MKTypography>
              <MKTypography variant="body" color="text">
                <Grid>
                  2740 Pillsbury Dr
                  Manhattan, KS 66502
                </Grid>
                <Grid>
                  <a href="mailto:785church@gmail.com">785church@gmail.com</a>
                </Grid>
                <Grid>
                  <a href="tel:+17857768717">(785)-776-8717</a>
                </Grid>
              </MKTypography>
            </Grid>

          </Container>

        </MKBox>
      </Card>
      <Container sx={{ height: "500px", '& iframe': { border: "none" } }}>

        <iframe title="CWC google image" src="https://www.google.com/maps/embed?pb=!4v1775421898805!6m8!1m7!1scLRkc_Uotm7JPB9ISbEqYQ!2m2!1d39.15587855596218!2d-96.538605989354!3f261.91573391015453!4f-12.036370118202882!5f0.7820865974627469" width="100%" height="100%" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </Container>
    </>
  );
}

export default Presentation;
